import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

class ModalReports extends Component {
    state = {
        modalDisplay: this.props.display
    }

    cerrarModal= () => {
        this.setState({
            modalDisplay: "none"
        }, () => {
            document.body.style.overflowY="visible";
            this.props.cerrar()
        })
    }

    render() {
        document.body.style.overflowY = "hidden";
        
        switch (this.props.footer){
            case false: return (
                <div className="custom-modal-fondo" style={{display: this.state.modalDisplay}}>
                    <div className="custom-modal-ventana">
                        <div align = "center">
                            {this.props.reporte}
                        </div>
                        <div align="left" style={{marginTop:10, marginLeft: 10}}>
                            <Row>
                                <Col md={1}>
                                    <button onClick={this.cerrarModal} className="btn btn-relleno-primary" title="Cerrar esta ventana" style={{borderWidth: 1}}><i className="fa fa-times"></i>Cerrar</button>
                                </Col>
                                <Col md={11}>
                                    <div className="custom-alert-info" style={{height:38, padding:10}}>{this.props.titulo}</div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            )
            default: return (
                <div className="custom-modal-fondo" style={{display: this.state.modalDisplay}}>
                    <div className="custom-modal-ventana">
                        <div align = "center">
                            {this.props.reporte}
                        </div>
                        <div align="left" style={{marginTop:10, marginLeft: 10}}>
                            <Row>
                                <Col md={1}>
                                    <button onClick={this.cerrarModal} className="btn btn-relleno-primary" title="Cerrar esta ventana" style={{borderWidth: 1}}><i className="fa fa-times"></i>Cerrar</button>
                                </Col>
                                <Col md={11}>
                                    <div className="custom-alert-info" style={{height:38, padding:10}}>{this.props.titulo}</div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            )
        }
    }
}
 
export default ModalReports;



// WEBPACK FOOTER //
// ./src/components/Reportes/ModalReports.jsx